import { createClient } from '@supabase/supabase-js';

let supabaseClient = null;

/**
 * Inicializa o cliente Supabase.
 * Tenta usar variáveis de ambiente diretas primeiro, depois tenta buscar via função Netlify.
 */
async function initSupabase() {
  if (supabaseClient) {
    return supabaseClient;
  }

  // Tenta usar variáveis de ambiente diretas (útil para desenvolvimento local)
  const directUrl = process.env.REACT_APP_SUPABASE_URL
  const directKey = process.env.REACT_APP_SUPABASE_ANON_KEY

  if (directUrl && directKey) {
    supabaseClient = createClient(directUrl, directKey);
    return supabaseClient;
  }

  // Se não tiver variáveis diretas, tenta buscar via função Netlify
  // Em dev local, só tenta se estiver rodando netlify dev (localhost:8888)
  // Em produção, sempre tenta a função Netlify
  try {
    const isLocal = process.env.NODE_ENV === 'development';
    const configUrl = isLocal
      ? 'http://localhost:8888/.netlify/functions/supabase-config'
      : `${window.location.origin}/.netlify/functions/supabase-config`;

    const response = await fetch(configUrl);
    if (!response.ok) {
      throw new Error(`Erro ao buscar config do Supabase: ${response.status}`);
    }

    const { url, anonKey } = await response.json();
    if (!url || !anonKey) {
      throw new Error('Configuração do Supabase incompleta');
    }

    supabaseClient = createClient(url, anonKey);
    return supabaseClient;
  } catch (error) {
    // Retorna null para permitir fallback para mock
    return null;
  }
}

/**
 * Retorna o cliente Supabase inicializado.
 * Se não estiver inicializado, tenta inicializar.
 */
export async function getSupabaseClient() {
  if (supabaseClient) {
    return supabaseClient;
  }
  return initSupabase();
}

/**
 * Retorna o cliente Supabase de forma síncrona (se já estiver inicializado).
 * Útil para casos onde você tem certeza que já foi inicializado.
 */
export function getSupabaseClientSync() {
  return supabaseClient;
}

